import { arrayToThresholds } from "./arrayToThresholds";
import { getClosestValue } from "./getClosestValue";

// Restriction
function getRestrictionLabelByValue(value: number) {
  const threshold = getClosestValue(RESTRICTION_THRESHOLDS, value);
  const index = RESTRICTION_THRESHOLDS.indexOf(threshold);
  return RESTRICTION_LABELS[index];
}

function getRestrictionThresholdByValue(value: number) {
  return getClosestValue(RESTRICTION_THRESHOLDS, value);
}

const RESTRICTION_LABELS = [
  "maintenance:priority.select.restriction.slider.0",
  "maintenance:priority.select.restriction.slider.50",
  "maintenance:priority.select.restriction.slider.100",
];

const RESTRICTION_THRESHOLDS = arrayToThresholds(RESTRICTION_LABELS);

export function getRestrictionProps() {
  return {
    thresholds: RESTRICTION_THRESHOLDS,
    labels: RESTRICTION_LABELS,
    getRestrictionLabelByValue,
    getRestrictionThresholdByValue,
  };
}

// Frequency
